import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Layout } from "../components/tag/Layout";
import { HeroBg, EyebrowPill } from "../components/tag/Primitives";
import { LogEntryCard } from "../components/tag/LogEntryCard";
import { api } from "../lib/api";

export default function Log() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api
      .get("/log")
      .then((res) => setEntries(res.data || []))
      .catch(() => setEntries([]))
      .finally(() => setLoading(false));
  }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.post("/subscribe", { email, type: "log" });
      toast.success("Subscribed to Builder's Log.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout title="Builder's Log | The Authority Gap" path="/log">
      <section style={{ background: "#090909", padding: "70px 32px 48px", position: "relative", overflow: "hidden", textAlign: "center" }}>
        <HeroBg />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 720, margin: "0 auto" }}>
          <div style={{ marginBottom: 24 }}><EyebrowPill>Build in Public</EyebrowPill></div>
          <h1 className="tag-h1" style={{ marginBottom: 18 }}>Builder's Log</h1>
          <p style={{ color: "#aaa", fontSize: 15, lineHeight: 1.6 }}>
            Weekly entries documenting what's being built, what's failing, and what's working. No editorial polish. Just the honest story.
          </p>
          <form onSubmit={subscribe} style={{ display: "flex", gap: 10, marginTop: 24, justifyContent: "center", flexWrap: "wrap" }}>
            <input
              data-testid="log-subscribe-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="tag-input"
              style={{ maxWidth: 280 }}
            />
            <button data-testid="log-subscribe-submit" type="submit" className="btn-primary" disabled={submitting}>
              {submitting ? "Subscribing…" : "Get the weekly log"}
            </button>
          </form>
        </div>
      </section>

      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "44px 32px" }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          {loading && (
            <div className="tag-card" data-testid="log-loading" style={{ textAlign: "center", color: "#777" }}>
              Loading entries…
            </div>
          )}
          {!loading && entries.length === 0 && (
            <div className="tag-card" data-testid="log-empty" style={{ textAlign: "center", color: "#bbb" }}>
              The first entry drops this week. Subscribe above to get it delivered.
            </div>
          )}
          {!loading && entries.length > 0 && entries.map((e) => <LogEntryCard key={e.id || e.entry_number} entry={e} />)}
        </div>
      </section>
    </Layout>
  );
}
